import { lazy } from 'react';

export const PaymentTransactionList = lazy(() => import('./PaymentTransactionList'));
